var _excluded = ["size", "title", "desc", "titleId", "descId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import Svg from './Svg';
import styled from 'styled-components';

var BaseComponent = function BaseComponent(_ref) {
  var size = _ref.size,
      title = _ref.title,
      desc = _ref.desc,
      titleId = _ref.titleId,
      descId = _ref.descId,
      props = _objectWithoutProperties(_ref, _excluded);

  var ariaLabelledBy = titleId ? titleId : '';
  ariaLabelledBy += desc && descId ? " ".concat(descId) : '';
  ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
  props['aria-labelledby'] = ariaLabelledBy;
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    title: title,
    titleId: titleId,
    desc: desc,
    descId: descId,
    "aria-labelledby": ariaLabelledBy,
    "aria-hidden": !ariaLabelledBy,
    fill: "currentcolor"
  }, props), !!title && /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title), !!desc && /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, desc), /*#__PURE__*/React.createElement("path", {
    d: "M6.568 4.675l6.302 2.76-2.228 2.326-4.78-4.224a.25.25 0 01-.042-.387l.44-.44a.251.251 0 01.308-.035zm10.403 6.847l2.76 6.315a.252.252 0 01-.036.309l-.44.439a.25.25 0 01-.387-.042l-4.23-4.8 2.333-2.221zM6.84 15.22l-2.692-2.262a.25.25 0 01-.074-.404l.56-.56a.25.25 0 01.31-.034l3.147.82-1.16 2.249c-.028.056-.064.12-.091.19zm4.794 1.102l.894 3.183c.024.087 0 .18-.064.245l-.598.596a.25.25 0 01-.404-.072l-2.275-2.707.17-.085 2.277-1.16zm8.426-12.025l.041.044.017.02c.22.273.25.64.266.864.074 1.216-.075 2.074-.47 2.698l-.036.06a1.713 1.713 0 01-.327.407l-7.48 7.127-.054.051-.065.033-2.817 1.437c-.346.188-1.266.442-1.737-.03-.51-.509-.192-1.438-.028-1.748l1.435-2.807.033-.065.05-.052 7.125-7.479c.303-.322.633-.48.951-.606.637-.24 1.447-.307 2.566-.205a.898.898 0 01.53.251zm-1.172 7.585a.248.248 0 01.354 0l1.06 1.061a.247.247 0 010 .353l-1.385 1.386-.87-1.959.841-.84zM11.11 4.104a.248.248 0 01.354 0l1.06 1.061a.247.247 0 010 .353l-.842.841-1.958-.869 1.386-1.386z"
  }));
};

var SvgAirplane = styled(BaseComponent).withConfig({
  displayName: "Airplane__SvgAirplane",
  componentId: "sc-4yjn7h-0"
})(["outline:none;"]);
SvgAirplane.isIcon = true;
SvgAirplane.defaultProps = {
  size: 24,
  tabIndex: -1,
  focusable: false,
  'aria-hidden': true,
  role: 'img'
};
export default SvgAirplane;